import React, { useCallback, useEffect, useState } from "react";
import { Form, Input, Row, Col, Modal, Button } from "antd";

import { Container } from "./styles";
import { openNotification } from "../../../../../../components/Notification";
import { useWidth } from "../../../../../../hooks";
import { sexualidadeService } from "../../../../../../services/resources/sexualidadeService";
import TextArea from "antd/lib/input/TextArea";

export function ModalAdd({ onClose, mode, codigo, reload }) {
  const [form] = Form.useForm();
  const { width } = useWidth();

  const [loading, setLoading] = useState(false);

  const [sexualidade, setSexualidade] = useState([]);

  const handleCloseModal = useCallback(() => {
    onClose();
  }, [onClose]);

  useEffect(() => {
    async function getSexualidade() {
      try {
        const { data } = await sexualidadeService.get(codigo);

        setSexualidade(data);
        form.setFieldsValue({
          descricao: data?.descricao,
          fundamentacao: data?.fundamentacao,
        });
      } catch (error) {
        openNotification(
          "error",
          <strong>Erro!</strong>,
          error?.response?.data?.detail
        );
      }
    }
    if (mode !== "onCreate") {
      getSexualidade();
    }
  }, [codigo, mode, form]);

  async function create() {
    try {
      setLoading(true);
      await sexualidadeService.create(form.getFieldsValue());
      handleCloseModal();
      openNotification(
        "success",
        <strong>Orientação Sexual adicionada com sucesso!</strong>
      );
      reload();
    } catch (error) {
      handleCloseModal();
      openNotification(
        "error",
        <strong>Não foi possível criar a Orientação Sexual!</strong>,
        error?.response?.data?.detail
      );
    } finally {
      setLoading(false);
    }
  }

  async function edit() {
    try {
      setLoading(true);
      await sexualidadeService.edit(codigo, form.getFieldsValue());
      handleCloseModal();
      openNotification("success", <strong>Orientação Sexual editado!</strong>);
      reload();
    } catch (error) {
      handleCloseModal();
      openNotification(
        "error",
        <strong>Não foi possível editar a Orientação Sexual!</strong>,
        error?.response?.data?.detail
      );
    } finally {
      setLoading(false);
    }
  }

  const footer = [
    mode === "onCreate" && (
      <Button key="submit" onClick={create} type="primary" loading={loading}>
        cadastrar
      </Button>
    ),
    mode === "onEdit" && (
      <Button
        key="submitUpdate"
        onClick={edit}
        type="primary"
        loading={loading}
      >
        atualizar
      </Button>
    ),
  ];

  return (
    <Modal
      title={
        (mode === "onCreate" && "NOVA ORIENTAÇÃO SEXUAL") ||
        (mode === "onEdit" &&
          `EDITAR ORIENTAÇÃO SEXUAL - ${sexualidade?.descricao}`) ||
        (mode === "onView" &&
          `DETALHES DA ORIENTAÇÃO SEXUAL - ${sexualidade?.descricao}`)
      }
      width={width > 1280 ? "40vw" : "100vw"}
      onCancel={onClose}
      visible
      footer={footer}
      centered
    >
      <Container>
        <Form form={form} name="sexualidade" layout="vertical">
          <Row>
            <Col span={24}>
              <Form.Item name="descricao" label={<span>Descrição:</span>}>
                <Input
                  type="text"
                  placeholder="insira a descrição"
                  autoComplete="none"
                  disabled={mode === "onView"}
                />
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                <Form.Item
                  name="fundamentacao"
                  label={<span>Fundamentação:</span>}
                >
                  <TextArea
                    autoSize
                    placeholder="Digite a fundamentação da orientação sexual"
                    disabled={mode === "onView"}
                  />
                </Form.Item>
              </Col>
          </Row>
        </Form>
      </Container>
    </Modal>
  );
}
